import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Signup.css"; // <-- Your Signup.css file
import { handleError, handleSuccess } from "../Utils";

const Signup = () => {
  const navigate = useNavigate();

  const [signUpInfo, setSignUpInfo] = useState({
    name: "",
    email: "",
    password: "",
  
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSignUpInfo((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }));
  };

  const handleSignup = async (e) => {
    e.preventDefault();

    // ✅ 'role' removed from validation
    const { name, email, password } = signUpInfo;
    if (!name || !email || !password) {
      return handleError("Please fill all the fields");
    }

    try {
      const url = "https://api.horizon.co.zm/auth/signup";
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        // ✅ signUpInfo (without role) is sent
        body: JSON.stringify(signUpInfo),
      });
      const result = await response.json();

      const { success, message, error } = result;

      if (success) {
        handleSuccess(message);
        setTimeout(() => {
          navigate("/login");
        }, 1000);
      } else if (error) {
        const errorMessage = error.details
          ? error.details[0].message
          : message;
        handleError(errorMessage || "Signup failed. Please try again.");
      } else if (!success) {
        handleError(message);
      }
    } catch (err) {
      handleError(err.message);
    }
  };

  return (
    <div className="signup-container">
      <div className="signup-card">
        {/* <img src={yourLogo} alt="Logo" className="logo" /> */}

        <h2>Sign Up</h2>
        <form onSubmit={handleSignup}>
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              onChange={handleChange}
              type="text"
              name="name"
              placeholder="Enter your name"
              autoFocus
              value={signUpInfo.name}
              className="form-control"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              onChange={handleChange}
              type="email"
              name="email"
              placeholder="Enter your email"
              value={signUpInfo.email}
              className="form-control"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              onChange={handleChange}
              type="password"
              name="password"
              placeholder="Enter your password"
              value={signUpInfo.password}
              className="form-control"
            />
          </div>

          {/* ✅ 'role' dropdown removed */}

          <button type="submit" className="signup-btn">
            Sign Up
          </button>

          <p className="login-link">
            Already have an account? <Link to="/login">Login</Link>
          </p>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Signup;